// src/components/featured-locations/featured-locations.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment CarouselFragment on EGDSCarousel {\n    carouselId\n    nextButton {\n      accessibility\n    }\n    previousButton {\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment ImageFragment on Image {\n    aspectRatio\n    description\n    url\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageLinkFragment on EGDSImageLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n      useRelativePath\n    }\n    image {\n      ...ImageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageItemFragment on EGDSImageLinkCard {\n    description\n    subTitle\n    link {\n      ...CrossLinkImageLinkFragment\n    }\n    title\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkImageLinkCardFragment on CrossLinkImageLinkCard {\n    gaiaId\n    imagelink {\n      ...CrossLinkImageItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    description\n    size\n    theme\n    title\n    id\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkStandardLinkFragment on EGDSStandardLink {\n    action {\n      resource {\n        value\n      }\n      target\n      analytics {\n        linkName\n        referrerId\n      }\n      accessibility\n    }\n    icon {\n      ...IconFragment\n    }\n    iconPosition\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkStandardItemFragment on CrossLinkStandardLink {\n    description\n    link {\n      ...CrossLinkStandardLinkFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment CrossLinkItemFragment on CrossLinkItem {\n    ...CrossLinkStandardItemFragment\n    ...CrossLinkImageLinkCardFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment MapFragment on EGDSBasicMap {\n    config {\n      accessToken\n      egdsMapProvider\n    }\n    label\n    markers {\n      ...MapMarkersFragment\n    }\n  }\n\n  fragment MapMarkersFragment on EGDSMapMarker {\n    markerPosition {\n      latitude\n      longitude\n    }\n    markerType\n    text\n    ... on MapFeatureEvent {\n      mapPinSelectedEvent\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  query FeaturedLocationsMapQuery(\n    $context: ContextInput!\n    $parameters: [CrossLinksParameterInput!]\n    $strategy: String!\n    $limit: Int!\n    $uriContext: UriContextInput!\n  ) {\n    crosslinkLocations(context: $context, limit: $limit, parameters: $parameters, strategyName: $strategy, uriContext: $uriContext) {\n      outline {\n        header\n      }\n      map {\n        ...MapFragment\n      }\n      carousel {\n        ...CarouselFragment\n      }\n      items {\n        ...CrossLinkItemFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
import React16, { useEffect as useEffect2 } from "react";
import { gql as gql14, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/carousel/carousel.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkHeading } from "uitk-react-text";
// ../internal/src/components/tracking/clickstream-constants.ts
var MAP_PIN_SELECTED_EVENT = "map_pin.selected";
var DESTINATIONS_MODULE_PRESENTED_EVENT_CONSTANTS = {
    EVENT_NAME: "destinations_module.presented",
    EVENT_TYPE: "Impression" /* IMPRESSION */ ,
    EVENT_VERSION: "1.1.0"
};
var MAP_CONTENT_PRESENTED_EVENT_CONSTANTS = {
    EVENT_NAME: "map_content.presented",
    EVENT_TYPE: "Impression" /* IMPRESSION */ ,
    EVENT_VERSION: "3.5.0"
};
var DESTINATIONS_CAROUSEL_NAV_SELECTED_EVENT_CONSTANTS = {
    EVENT_NAME: "destinations_carousel_nav.selected",
    EVENT_TYPE: "Interaction" /* INTERACTION */ ,
    EVENT_VERSION: "1.2.0"
};
var DESTINATIONS_PROPERTIES_CAROUSEL_EVENT_CONSTANTS = {
    ACTION_LOCATION: "destination_properties",
    PAGE_NAME: "HOMEPAGE"
};
// ../internal/src/components/tracking/clickstream-utils.ts
var clickstreamEventBuilder = function(clickStreamEventConstants) {
    return {
        event: {
            event_type: clickStreamEventConstants.EVENT_TYPE,
            event_name: clickStreamEventConstants.EVENT_NAME,
            event_version: clickStreamEventConstants.EVENT_VERSION
        }
    };
};
var clickStreamEventBuilderWithDestination = function(rawEventsPayload) {
    var eventsPayload = JSON.parse(rawEventsPayload);
    var event_data = Object.values(eventsPayload.events[MAP_PIN_SELECTED_EVENT])[0].event_data;
    return {
        event: {
            event_type: event_data.event.event_type,
            event_name: event_data.event.event_name,
            event_version: event_data.event.event_version
        },
        destination: event_data.destination
    };
};
// ../internal/src/components/carousel/utils.ts
var CAROUSEL_ITEMS_VISIBLE = {
    sm: 1,
    md: 3,
    lg: 5
};
// ../internal/src/components/carousel/carousel.tsx
var fragment = gql(_templateObject());
var Carousel = function(props) {
    var _nextButton, _previousButton;
    var onSelect = props.onSelect, carouselRef = props.carouselRef, _props_data = props.data, carouselId = _props_data.carouselId, nextButton = _props_data.nextButton, previousButton = _props_data.previousButton, children = props.children;
    var _useBexApi = useBexApi(), device = _useBexApi.context.device;
    var isMobile = device.type === "MOBILE_PHONE" /* MOBILE_PHONE */ ;
    var track = useEgClickstream();
    var publishClickstreamEvent = function(clickstreamEventConstants) {
        var clickstreamEvent = clickstreamEventBuilder(clickstreamEventConstants);
        track(clickstreamEvent);
    };
    var analyticsCarouselTracker = {
        callback: function(referrerId) {
            var isNavClicked = referrerId.includes("clickRight") || referrerId.includes("clickLeft");
            if (isNavClicked) {
                publishClickstreamEvent(DESTINATIONS_CAROUSEL_NAV_SELECTED_EVENT_CONSTANTS);
            }
        },
        id: "destinations_carousel_nav.selected"
    };
    var onIndexChange = function(i) {
        if (isMobile) {
            onSelect(i);
        }
    };
    var _nextButton_accessibility, _previousButton_accessibility;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(UitkHeading, {
        className: "is-visually-hidden",
        tag: "h3"
    }, carouselId), /* @__PURE__ */ React.createElement(UitkCarousel, {
        analytics: analyticsCarouselTracker,
        buttonText: {
            nextButton: (_nextButton_accessibility = (_nextButton = nextButton) === null || _nextButton === void 0 ? void 0 : _nextButton.accessibility) !== null && _nextButton_accessibility !== void 0 ? _nextButton_accessibility : "",
            prevButton: (_previousButton_accessibility = (_previousButton = previousButton) === null || _previousButton === void 0 ? void 0 : _previousButton.accessibility) !== null && _previousButton_accessibility !== void 0 ? _previousButton_accessibility : ""
        },
        itemsMaxHeight: true,
        itemsVisible: CAROUSEL_ITEMS_VISIBLE,
        pageBy: 1,
        peek: true,
        carouselRef: carouselRef,
        onIndexChange: onIndexChange
    }, children));
};
Carousel.displayName = "FeaturedLocationsCarousel";
Carousel.fragment = fragment;
// ../internal/src/components/crosslink-items/crosslink-item.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/crosslink-items/crosslink-image-link-card.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
// ../internal/src/components/crosslink-items/crosslink-image-item.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { useClickTracker as useClickTracker2, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
// ../internal/src/components/crosslink-items/micro-components/clickstream-constants.ts
var DESTINATIONS_CAROUSEL_CARD_SELECTED_EVENT_CONSTANTS = {
    EVENT_NAME: "destinations_carousel_card.selected",
    EVENT_TYPE: "Interaction" /* INTERACTION */ ,
    EVENT_VERSION: "1.2.0"
};
// ../internal/src/components/crosslink-items/micro-components/clickstream-utils.ts
var clickstreamEventBuilder2 = function(clickStreamEventConstants) {
    return {
        event: {
            event_type: clickStreamEventConstants.EVENT_TYPE,
            event_name: clickStreamEventConstants.EVENT_NAME,
            event_version: clickStreamEventConstants.EVENT_VERSION
        }
    };
};
// ../internal/src/components/crosslink-items/micro-components/select-view.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
// ../internal/src/components/crosslink-items/crosslink-image-link.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
// ../internal/src/components/image/image.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "uitk-react-images";
// ../internal/src/components/image/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj;
var aspectRatioMapper = (_obj = {}, _define_property(_obj, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _define_property(_obj, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj);
// ../internal/src/components/image/image.tsx
var fragment2 = gql2(_templateObject1());
var Image = function(props) {
    var _props_data = props.data, aspectRatio = _props_data.aspectRatio, description = _props_data.description, url = _props_data.url;
    return /* @__PURE__ */ React2.createElement(UitkFigure, {
        ratio: aspectRatio ? aspectRatioMapper[aspectRatio] : UitkFigureAspectRatioType2.R16_9
    }, /* @__PURE__ */ React2.createElement(UitkImage, {
        placeholderImage: true,
        alt: description,
        src: url,
        lazyLoading: "lazy"
    }));
};
Image.fragment = fragment2;
Image.displayName = "Image";
// ../internal/src/components/crosslink-items/crosslink-image-link.tsx
var fragment3 = gql3(_templateObject2(), Image.fragment);
var CrossLinkImageLink = function(props) {
    var data = props.data, _props_isLinkInsideOfTheCard = props.isLinkInsideOfTheCard, isLinkInsideOfTheCard = _props_isLinkInsideOfTheCard === void 0 ? true : _props_isLinkInsideOfTheCard;
    var image = data.image, action = data.action;
    var analytics = action.analytics, resource = action.resource, target = action.target;
    var clickTracker = useClickTracker();
    var onClickCapture = React3.useCallback(function() {
        return clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        clickTracker
    ]);
    if (data.__typename === "EGDSImageLink") {
        if (isLinkInsideOfTheCard) {
            return /* @__PURE__ */ React3.createElement(Image, {
                data: image
            });
        }
        return /* @__PURE__ */ React3.createElement(UitkLink, {
            onClickCapture: onClickCapture
        }, /* @__PURE__ */ React3.createElement("a", {
            href: resource.value,
            target: target
        }, /* @__PURE__ */ React3.createElement(Image, {
            data: image
        })));
    }
    return null;
};
CrossLinkImageLink.fragment = fragment3;
CrossLinkImageLink.displayName = "CrossLinkImageLink";
// ../internal/src/components/crosslink-items/micro-components/crosslink-featured-locations-image-item.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkBadgeStandard } from "uitk-react-badge";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkHeading as UitkHeading2, UitkSubheading } from "uitk-react-text";
var fragment4 = gql4(_templateObject3(), CrossLinkImageLink.fragment);
var overlayLayout = {
    top: "zero",
    right: "zero",
    bottom: "zero",
    left: "zero"
};
var FeaturedLocationsComponent = function(props) {
    var data = props.data, headingTag = props.headingTag;
    var link = data.link, description = data.description, title = data.title, subTitle = data.subTitle;
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React4.createElement(CrossLinkImageLink, {
        data: link
    }), /* @__PURE__ */ React4.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: overlayLayout,
        cloneElement: true,
        "aria-hidden": true
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex, {
        alignItems: "center",
        justifyContent: "center"
    }, description && /* @__PURE__ */ React4.createElement(UitkBadgeStandard, {
        text: description
    })))), /* @__PURE__ */ React4.createElement(UitkCardContentSection, null, title && /* @__PURE__ */ React4.createElement(UitkHeading2, {
        tag: headingTag,
        overflow: "truncate"
    }, title), subTitle && /* @__PURE__ */ React4.createElement(UitkSubheading, null, " ", subTitle, " ")));
};
FeaturedLocationsComponent.fragment = fragment4;
FeaturedLocationsComponent.displayName = "FeaturedLocationsComponent";
// ../internal/src/components/crosslink-items/micro-components/crosslink-regular-image-item.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkHeading as UitkHeading3, UitkSubheading as UitkSubheading2 } from "uitk-react-text";
var fragment5 = gql5(_templateObject4(), CrossLinkImageLink.fragment);
var RegularComponent = function(props) {
    var data = props.data, headingTag = props.headingTag;
    var link = data.link, title = data.title, description = data.description;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(UitkLayoutPosition2, {
        type: "relative"
    }, /* @__PURE__ */ React5.createElement(CrossLinkImageLink, {
        data: link
    })), /* @__PURE__ */ React5.createElement(UitkCardContentSection2, null, title && /* @__PURE__ */ React5.createElement(UitkHeading3, {
        tag: headingTag,
        overflow: "truncate"
    }, title), description && /* @__PURE__ */ React5.createElement(UitkSubheading2, null, description)));
};
RegularComponent.fragment = fragment5;
RegularComponent.displayName = "RegularComponent";
// ../internal/src/components/crosslink-items/micro-components/select-view.tsx
var fragment6 = gql6(_templateObject5(), CrossLinkImageLink.fragment);
var SelectView = function(props) {
    var view = props.view, headingTag = props.headingTag, data = props.data;
    var displayByView = {
        regular: function Regular() {
            return /* @__PURE__ */ React6.createElement(RegularComponent, {
                headingTag: headingTag,
                data: data
            });
        },
        featured: function FeaturedLocations() {
            return /* @__PURE__ */ React6.createElement(FeaturedLocationsComponent, {
                headingTag: headingTag,
                data: data
            });
        }
    };
    return displayByView[view]();
};
SelectView.fragment = fragment6;
SelectView.displayName = "SelectView";
// ../internal/src/components/crosslink-items/crosslink-image-item.tsx
var fragment7 = gql7(_templateObject6(), CrossLinkImageLink.fragment);
var CrossLinkImageItem = function(props) {
    var data = props.data, padded = props.padded, border = props.border, selected = props.selected, _props_headingTag = props.headingTag, headingTag = _props_headingTag === void 0 ? "h6" : _props_headingTag, onSelect = props.onSelect, onDeselect = props.onDeselect, _props_view = props.view, view = _props_view === void 0 ? "regular" : _props_view;
    var link = data.link;
    var action = link.action;
    var clickTracker = useClickTracker2();
    var track = useEgClickstream2();
    var onClickCapture = React7.useCallback(function() {
        var publishClickstreamEvent = function(clickstreamEventConstants) {
            var clickstreamEvent = clickstreamEventBuilder2(clickstreamEventConstants);
            track(clickstreamEvent);
        };
        clickTracker(action.analytics.referrerId, action.analytics.linkName);
        publishClickstreamEvent(DESTINATIONS_CAROUSEL_CARD_SELECTED_EVENT_CONSTANTS);
    }, [
        action.analytics.linkName,
        action.analytics.referrerId,
        clickTracker,
        track
    ]);
    return /* @__PURE__ */ React7.createElement(UitkCard, {
        padded: padded,
        border: border,
        selected: selected
    }, /* @__PURE__ */ React7.createElement(UitkCardLink, null, /* @__PURE__ */ React7.createElement("a", {
        href: action.resource.value,
        onClickCapture: onClickCapture,
        onMouseEnter: onSelect,
        onMouseLeave: onDeselect
    }, action.accessibility)), /* @__PURE__ */ React7.createElement(SelectView, {
        data: data,
        view: view,
        headingTag: headingTag
    }));
};
CrossLinkImageItem.fragment = fragment7;
CrossLinkImageItem.displayName = "CrossLinkImageItem";
// ../internal/src/components/crosslink-items/crosslink-image-link-card.tsx
var fragment8 = gql8(_templateObject7(), CrossLinkImageItem.fragment);
var CrossLinkImageLinkCard = function(props) {
    var data = props.data, onSelect = props.onSelect, onDeselect = props.onDeselect, selected = props.selected, view = props.view;
    var gaiaId = data.gaiaId, imagelink = data.imagelink;
    return /* @__PURE__ */ React8.createElement("div", {
        "data-gaiaid": gaiaId
    }, /* @__PURE__ */ React8.createElement(CrossLinkImageItem, {
        border: true,
        data: imagelink,
        selected: selected,
        "data-gaiaid": gaiaId,
        view: view,
        onDeselect: onDeselect,
        onSelect: onSelect
    }));
};
CrossLinkImageLinkCard.fragment = fragment8;
CrossLinkImageLinkCard.displayName = "CrossLinksImageLinkCard";
// ../internal/src/components/crosslink-items/crosslink-standard-item.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
// ../internal/src/components/crosslink-items/crosslink-standard-link.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/icon/icon.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment9 = gql9(_templateObject8());
var _obj1;
var mapper = (_obj1 = {}, _define_property(_obj1, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize.EXTRA_SMALL), _define_property(_obj1, "SMALL" /* SMALL */ , UitkIconSize.SMALL), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , UitkIconSize.MEDIUM), _define_property(_obj1, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize.MEDIUM), _define_property(_obj1, "LARGE" /* LARGE */ , UitkIconSize.LARGE), _define_property(_obj1, "XLARGE" /* XLARGE */ , UitkIconSize.XLARGE), _obj1);
var Icon = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React9.createElement(UitkIcon, {
        id: data.id,
        name: data.id,
        size: data.size ? mapper[data.size] : void 0,
        title: data.title || void 0,
        description: data.description
    });
};
Icon.fragment = fragment9;
Icon.displayName = "Icon";
// ../internal/src/components/crosslink-items/crosslink-standard-link.tsx
var fragment10 = gql10(_templateObject9(), Icon.fragment);
var CrossLinkStandardLink = function(props) {
    var data = props.data, target = props.target;
    var action = data.action, icon = data.icon, text = data.text, iconPosition = data.iconPosition;
    var analytics = action.analytics, resource = action.resource;
    var clickTracker = useClickTracker3();
    var onClickCapture = React10.useCallback(function() {
        return clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        clickTracker
    ]);
    return /* @__PURE__ */ React10.createElement(UitkText, {
        wordBreak: true
    }, /* @__PURE__ */ React10.createElement(UitkLink2, {
        onClickCapture: onClickCapture
    }, /* @__PURE__ */ React10.createElement("a", {
        href: resource.value,
        target: target
    }, icon && iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React10.createElement(Icon, {
        data: icon
    }), text, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React10.createElement(Icon, {
        data: icon
    }), action.accessibility && /* @__PURE__ */ React10.createElement(UitkText, {
        className: "is-visually-hidden"
    }, action.accessibility))));
};
CrossLinkStandardLink.fragment = fragment10;
CrossLinkStandardLink.displayName = "CrossLinkStandardLink";
// ../internal/src/components/crosslink-items/crosslink-standard-item.tsx
var fragment11 = gql11(_templateObject10(), CrossLinkStandardLink.fragment);
var CrossLinkStandardItem = function(props) {
    var data = props.data, target = props.target;
    var description = data.description, link = data.link;
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(CrossLinkStandardLink, {
        target: target,
        data: link
    }), description && /* @__PURE__ */ React11.createElement(UitkParagraph, {
        size: 3
    }, description));
};
CrossLinkStandardItem.fragment = fragment11;
CrossLinkStandardItem.displayName = "CrossLinkStandardItem";
// ../internal/src/components/crosslink-items/crosslink-item.tsx
var fragment12 = gql12(_templateObject11(), CrossLinkStandardItem.fragment, CrossLinkImageLinkCard.fragment);
var CrossLinkItem = function(props) {
    var data = props.data, onSelect = props.onSelect, onDeselect = props.onDeselect, selected = props.selected, _props_target = props.target, target = _props_target === void 0 ? "_blank" /* BLANK */  : _props_target, view = props.view;
    if (data.__typename === "CrossLinkStandardLink") {
        return /* @__PURE__ */ React12.createElement(CrossLinkStandardItem, {
            target: target,
            data: data
        });
    }
    if (data.__typename === "CrossLinkImageLinkCard") {
        return /* @__PURE__ */ React12.createElement(CrossLinkImageLinkCard, {
            data: data,
            view: view,
            selected: selected,
            onDeselect: onDeselect,
            onSelect: onSelect
        });
    }
    return null;
};
CrossLinkItem.fragment = fragment12;
CrossLinkItem.displayName = "CrossLinkItem";
// ../internal/src/components/map/map.tsx
import React13, { useEffect } from "react";
import { gql as gql13 } from "@apollo/client";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkFigure as UitkFigure2 } from "uitk-react-images";
import { UitkEGMaps, UitkEGMapsType } from "uitk-react-map";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
// ../internal/src/components/map/utils.ts
import { defaultViewSizes } from "@shared-ui/viewport-context";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType3 } from "uitk-react-images";
var maxHeight = 380;
var MAP_ASPECT_RATIOS = _define_property({}, defaultViewSizes.SMALL, UitkFigureAspectRatioType3.R4_3);
// ../internal/src/components/map/map.tsx
var fragment13 = gql13(_templateObject12());
var egMapsConfig = {
    markers: {
        product: {
            markerType: {
                locationPin: "text"
            },
            actionOnFeatureSelect: {
                default: [
                    "highlight",
                    "showRoutes"
                ]
            }
        },
        place: {
            markerType: {
                locationPin: "text"
            }
        }
    },
    googleMaps: {
        gmapsAddConfig: {
            gestureHandling: "cooperative",
            zoomControl: false,
            streetViewControl: false
        }
    }
};
var MapComponent = function(props) {
    var mapRef = props.mapRef, carouselRef = props.carouselRef, setSelectedCard = props.setSelectedCard, _props_data = props.data, label = _props_data.label, config = _props_data.config, markers = _props_data.markers, dataCarousel = props.dataCarousel;
    var track = useEgClickstream3();
    var publishClickstreamEvent = React13.useCallback(function(clickstreamEventConstants) {
        var clickstreamEvent = clickstreamEventBuilder(clickstreamEventConstants);
        track(clickstreamEvent);
    }, [
        track
    ]);
    useEffect(function() {
        publishClickstreamEvent(MAP_CONTENT_PRESENTED_EVENT_CONSTANTS);
    }, []);
    var viewportSize = useMediaQueries({
        viewSizes: defaultViewSizes2
    });
    var aspectRatio = MAP_ASPECT_RATIOS[viewportSize];
    var features = markers.map(function(marker, i) {
        var _items, _items1;
        var _marker_markerPosition = marker.markerPosition, latitude = _marker_markerPosition.latitude, longitude = _marker_markerPosition.longitude, text = marker.text;
        var accessibilityText;
        var items = dataCarousel[i];
        if (((_items = items) === null || _items === void 0 ? void 0 : _items.__typename) === "CrossLinkImageLinkCard") {
            var _items_imagelink_link_action, _items_imagelink_link, _items_imagelink, _items2;
            accessibilityText = (_items2 = items) === null || _items2 === void 0 ? void 0 : (_items_imagelink = _items2.imagelink) === null || _items_imagelink === void 0 ? void 0 : (_items_imagelink_link = _items_imagelink.link) === null || _items_imagelink_link === void 0 ? void 0 : (_items_imagelink_link_action = _items_imagelink_link.action) === null || _items_imagelink_link_action === void 0 ? void 0 : _items_imagelink_link_action.accessibility;
        }
        if (((_items1 = items) === null || _items1 === void 0 ? void 0 : _items1.__typename) === "CrossLinkStandardLink") {
            var _items_link_action, _items_link, _items3;
            accessibilityText = (_items3 = items) === null || _items3 === void 0 ? void 0 : (_items_link = _items3.link) === null || _items_link === void 0 ? void 0 : (_items_link_action = _items_link.action) === null || _items_link_action === void 0 ? void 0 : _items_link_action.accessibility;
        }
        var ariaLabels = {
            default: "".concat(text, " ").concat(accessibilityText),
            onSelect: "".concat(text, " ").concat(accessibilityText)
        };
        return {
            id: i,
            lat: latitude,
            lng: longitude,
            type: "place",
            text: text !== null && text !== void 0 ? text : void 0,
            status: "unknown",
            qualifiers: [
                "locationPin"
            ],
            ariaLabels: ariaLabels
        };
    });
    var onMarkerSelectionChanged = React13.useCallback(function(event) {
        var action = event.action, feature = event.feature;
        if (action === "clearSelection") {
            if (setSelectedCard) {
                setSelectedCard(-1);
            }
        } else if (action === "select") {
            if (setSelectedCard) {
                setSelectedCard(feature.id);
                var eventData = markers[feature.id];
                track(clickStreamEventBuilderWithDestination(eventData.mapPinSelectedEvent));
            }
            if (carouselRef.current) {
                carouselRef.current.changeIndex(feature.id);
            }
        }
    }, [
        carouselRef,
        setSelectedCard
    ]);
    var beforeInit = React13.useCallback(function(map2) {
        map2.addSelectionChangeListener(onMarkerSelectionChanged, "selectionchange");
    }, [
        onMarkerSelectionChanged
    ]);
    var initialViewport = features.filter(function(f) {
        return f.lat !== void 0 && f.lng !== void 0;
    }).map(function(f) {
        return {
            lat: f.lat || 0,
            lng: f.lng || 0
        };
    });
    if (viewportSize < defaultViewSizes2.MEDIUM && egMapsConfig && egMapsConfig.googleMaps && egMapsConfig.googleMaps.gmapsAddConfig) {
        egMapsConfig.googleMaps.gmapsAddConfig.gestureHandling = "none";
    }
    var map = /* @__PURE__ */ React13.createElement(UitkEGMaps, {
        accessToken: config.accessToken,
        mapType: UitkEGMapsType[config.egdsMapProvider],
        features: features,
        mapConfig: egMapsConfig,
        innerRef: mapRef,
        beforeInit: beforeInit,
        initialViewport: initialViewport,
        height: viewportSize >= defaultViewSizes2.MEDIUM ? "".concat(maxHeight, "px") : "100%"
    });
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(UitkHeading4, {
        className: "is-visually-hidden",
        tag: "h3"
    }, label), aspectRatio ? /* @__PURE__ */ React13.createElement(UitkFigure2, {
        ratio: aspectRatio,
        style: {
            maxHeight: maxHeight
        }
    }, map) : map);
};
MapComponent.displayName = "FeaturedLocationsMap";
MapComponent.fragment = fragment13;
// src/components/featured-locations/featured-locations.tsx
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5 } from "uitk-react-text";
// src/components/featured-locations/featured-locations-skeleton.tsx
import React14 from "react";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkCarousel as UitkCarousel2 } from "uitk-react-carousel";
import { UitkFigure as UitkFigure3, UitkFigureAspectRatioType as UitkFigureAspectRatioType4 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkBlockSkeleton, UitkLineSkeleton } from "uitk-react-skeleton";
// src/utils/constants.ts
var maxHeight2 = 380;
// src/components/featured-locations/featured-locations-skeleton.tsx
var FeaturedLocationsSkeleton = function() {
    var cards = new Array(5).fill(0).map(function(_, i) {
        return /* @__PURE__ */ React14.createElement(UitkCard2, {
            key: i
        }, /* @__PURE__ */ React14.createElement(UitkFigure3, {
            ratio: UitkFigureAspectRatioType4.R4_3
        }, /* @__PURE__ */ React14.createElement(UitkBlockSkeleton, null)), /* @__PURE__ */ React14.createElement(UitkCardContentSection3, {
            padded: true
        }, /* @__PURE__ */ React14.createElement(UitkLayoutFlex2, {
            direction: "column",
            space: "four"
        }, /* @__PURE__ */ React14.createElement(UitkLineSkeleton, null), /* @__PURE__ */ React14.createElement(UitkLineSkeleton, {
            type: "secondary"
        }))));
    });
    return /* @__PURE__ */ React14.createElement(UitkCard2, {
        backgroundTheme: "secondary"
    }, /* @__PURE__ */ React14.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React14.createElement(UitkLineSkeleton, {
        type: "primary"
    })), /* @__PURE__ */ React14.createElement(UitkLayoutFlex2, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React14.createElement(UitkFigure3, {
        ratio: UitkFigureAspectRatioType4.R21_9,
        style: {
            maxHeight: maxHeight2
        }
    }, /* @__PURE__ */ React14.createElement(UitkBlockSkeleton, null)), /* @__PURE__ */ React14.createElement(UitkCarousel2, {
        buttonText: {
            prevButton: "Prev",
            nextButton: "Next"
        },
        itemsVisible: {
            sm: 1,
            md: 3,
            lg: 5
        },
        pageBy: 1,
        peek: true
    }, cards)));
};
// src/components/featured-locations/property-destinations-carousels.tsx
import React15 from "react";
import { DestinationPropertiesCarousel } from "@shared-ui/retail-lodging-destination-properties-carousel";
import { UitkSpacing } from "uitk-react-spacing";
var MAX_CAROUSEL_COUNT = 6;
var PropertyDestinationsCarousels = function(param) {
    var carousel = param.carousel, carouselTitle = param.carouselTitle, _param_isRouteAndHoverDifferent = param.isRouteAndHoverDifferent, isRouteAndHoverDifferent = _param_isRouteAndHoverDifferent === void 0 ? false : _param_isRouteAndHoverDifferent;
    var _carousel;
    return (_carousel = carousel) === null || _carousel === void 0 ? void 0 : _carousel.slice(0, MAX_CAROUSEL_COUNT).map(function(item, i) {
        var _carouselTitle;
        var propertySearchCriteriaInput;
        if (item.__typename === "CrossLinkImageLinkCard" && item.imagelink.__typename === "EGDSImageLinkCard") {
            propertySearchCriteriaInput = {
                primary: {
                    destination: {
                        regionId: item.gaiaId,
                        regionName: item.imagelink.title
                    },
                    rooms: [
                        {
                            adults: 1
                        }
                    ]
                }
            };
        }
        var title = (_carouselTitle = carouselTitle) === null || _carouselTitle === void 0 ? void 0 : _carouselTitle.replace("{{destination}}", item.imagelink.title);
        return /* @__PURE__ */ React15.createElement(UitkSpacing, {
            margin: {
                blockstart: "six"
            },
            key: "destination-properties-carousel-".concat(i)
        }, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(DestinationPropertiesCarousel, {
            clickstreamConfig: DESTINATIONS_PROPERTIES_CAROUSEL_EVENT_CONSTANTS,
            inputs: {
                propertySearchCriteriaInput: propertySearchCriteriaInput,
                title: title
            },
            isRouteAndHoverDifferent: isRouteAndHoverDifferent
        })));
    });
};
// src/components/featured-locations/featured-locations.tsx
var __Query = gql14(_templateObject13(), Carousel.fragment, MapComponent.fragment, CrossLinkItem.fragment);
var headingSpacing = {
    block: "four"
};
var FeaturedLocationsMap = function(props) {
    var _data_crosslinkLocations, _data, _data_crosslinkLocations_map_markers, _data_crosslinkLocations_map, _data_crosslinkLocations1, _data1, _data_crosslinkLocations_items, _data_crosslinkLocations2, _data2, _outline;
    var inputs = props.inputs, skipSsr = props.skipSsr, showCarousels = props.showCarousels, carouselTitle = props.carouselTitle;
    var context = useBexApi2().context;
    var track = useEgClickstream4();
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var mapRef = React16.useRef(null);
    var carouselRef = React16.useRef(null);
    var _React16_useState = _sliced_to_array(React16.useState(-1), 2), selectedCardIndex = _React16_useState[0], setSelectedCardIndex = _React16_useState[1];
    var publishClickstreamEvent = function(clickstreamEventConstants) {
        var clickstreamEvent = clickstreamEventBuilder(clickstreamEventConstants);
        track(clickstreamEvent);
    };
    var handleOnSelect = function(i) {
        var _mapRef_current_map, _mapRef_current;
        var egMap = (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : (_mapRef_current_map = _mapRef_current.map) === null || _mapRef_current_map === void 0 ? void 0 : _mapRef_current_map.call(_mapRef_current);
        if (egMap) {
            var _map_markers_i_markerType;
            var featureType = (_map_markers_i_markerType = map.markers[i].markerType) !== null && _map_markers_i_markerType !== void 0 ? _map_markers_i_markerType : "product";
            egMap.selectFeature(i, featureType);
        }
        setSelectedCardIndex(i);
    };
    var handleOnDeselect = function() {
        var _mapRef_current_map, _mapRef_current;
        var egMap = (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : (_mapRef_current_map = _mapRef_current.map) === null || _mapRef_current_map === void 0 ? void 0 : _mapRef_current_map.call(_mapRef_current);
        if (egMap) {
            egMap.clearSelectedFeature();
        }
        setSelectedCardIndex(-1);
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    useEffect2(function() {
        var _data_crosslinkLocations, _data;
        if ((_data = data) === null || _data === void 0 ? void 0 : (_data_crosslinkLocations = _data.crosslinkLocations) === null || _data_crosslinkLocations === void 0 ? void 0 : _data_crosslinkLocations.map) {
            publishClickstreamEvent(DESTINATIONS_MODULE_PRESENTED_EVENT_CONSTANTS);
        }
    }, [
        (_data = data) === null || _data === void 0 ? void 0 : (_data_crosslinkLocations = _data.crosslinkLocations) === null || _data_crosslinkLocations === void 0 ? void 0 : _data_crosslinkLocations.map
    ]);
    if (loading) {
        return /* @__PURE__ */ React16.createElement(FeaturedLocationsSkeleton, null);
    }
    if (error || !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_crosslinkLocations1 = _data1.crosslinkLocations) === null || _data_crosslinkLocations1 === void 0 ? void 0 : (_data_crosslinkLocations_map = _data_crosslinkLocations1.map) === null || _data_crosslinkLocations_map === void 0 ? void 0 : (_data_crosslinkLocations_map_markers = _data_crosslinkLocations_map.markers) === null || _data_crosslinkLocations_map_markers === void 0 ? void 0 : _data_crosslinkLocations_map_markers.length) || !((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_crosslinkLocations2 = _data2.crosslinkLocations) === null || _data_crosslinkLocations2 === void 0 ? void 0 : (_data_crosslinkLocations_items = _data_crosslinkLocations2.items) === null || _data_crosslinkLocations_items === void 0 ? void 0 : _data_crosslinkLocations_items.length)) {
        return null;
    }
    var _data_crosslinkLocations3 = data.crosslinkLocations, outline = _data_crosslinkLocations3.outline, map = _data_crosslinkLocations3.map, carousel = _data_crosslinkLocations3.carousel, items = _data_crosslinkLocations3.items;
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(UitkLayoutFlex3, {
        direction: "column",
        space: "two"
    }, /* @__PURE__ */ React16.createElement(UitkSpacing2, {
        padding: headingSpacing
    }, /* @__PURE__ */ React16.createElement(UitkHeading5, {
        tag: "h2",
        size: 3
    }, (_outline = outline) === null || _outline === void 0 ? void 0 : _outline.header)), /* @__PURE__ */ React16.createElement(MapComponent, {
        setSelectedCard: setSelectedCardIndex,
        mapRef: mapRef,
        carouselRef: carouselRef,
        data: map,
        dataCarousel: items
    }), carousel && /* @__PURE__ */ React16.createElement(Carousel, {
        onSelect: handleOnSelect,
        carouselRef: carouselRef,
        markers: map.markers,
        data: carousel
    }, items.map(function(item, i) {
        return /* @__PURE__ */ React16.createElement(CrossLinkItem, {
            selected: i === selectedCardIndex,
            data: item,
            key: i,
            onSelect: function() {
                return handleOnSelect(i);
            },
            onDeselect: handleOnDeselect,
            view: "featured" /* FEATURED */ 
        });
    }))), showCarousels && /* @__PURE__ */ React16.createElement(PropertyDestinationsCarousels, {
        carousel: items,
        carouselTitle: carouselTitle
    }));
};
FeaturedLocationsMap.displayName = "sharedui-FeaturedLocationsContainer";
export { FeaturedLocationsMap };
//# sourceMappingURL=index.js.map